import Reflux from 'reflux';

const NotificationDetail = Reflux.createActions([
  'read',
  'nextNotifications',
  'prevNotifications'
]);

export default NotificationDetail;



// WEBPACK FOOTER //
// ./src/js/actions/NotificationDetail.js